export const SET_TIME_WINDOW = 'SET_TIME_WINDOW';
export const SET_REFESH_TIMER = 'SET_REFESH_TIMER';
